import { render, staticRenderFns } from "./RegionDia.vue?vue&type=template&id=d0732230&scoped=true"
import script from "./RegionDia.vue?vue&type=script&lang=js"
export * from "./RegionDia.vue?vue&type=script&lang=js"
import style0 from "./RegionDia.vue?vue&type=style&index=0&id=d0732230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0732230",
  null
  
)

export default component.exports